<header class="header-auto home" data-aos="fade-up" data-aos-duration="2000">
    <div class="container-l">
      <div class="w-layout-grid grid _1er-header-home">
        <div id="w-node-_58687edf-5651-ccd3-5068-c4493058b570-88a991eb" class="grid-item">
          <div data-w-id="b38a2f47-7c2f-bf10-ba0c-5bc2afdc5327"  class="topline-wrapper b-30px l-70px">
            <div class="topline-line bg-background home-header"></div>
            <div class="text-topline text-background">Hudson Real estate</div>
          </div>
          <div class="text-animation-wrapper">
            <div class="h1-home text-background"><span data-w-id="2f27eace-54d6-d85f-a2c1-c7d0f5961ca7"  class="h-text-span">The value of</span><span data-w-id="2f27eace-54d6-d85f-a2c1-c7d0f5961ca9"  class="h-text-span l-135px">living in DUBai</span></div>
          </div>
          <div data-w-id="58687edf-5651-ccd3-5068-c4493058b582"  class="button-wrapper t-30px l-140px">
            <a [routerLink]="['/buy-properties']" class="button button-primary r-25px w-button">Property to buy</a>
            <div class="button-wrapper-inner xs-t-20px">
              <a [routerLink]="['/rent-properties']" class="button button-link button-line w-button">Property to rent</a>
            </div>
          </div>
        </div>
      </div>
      <div class="scroll-wrap">
        <div class="txt-scroll">Scroll</div>
        <div class="scroll-line">
          <div data-w-id="e2060895-22f9-becf-516a-e481cc8c70c8" class="scroll-inner"></div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-dark"><img src="../../assets/images/Hudson-Header-02.jpg" loading="lazy" sizes="100vw" srcset="../../assets/images/Hudson-Header-02-p-500.jpeg 500w, ../../assets/images/Hudson-Header-02.jpg 2000w" alt="" class="image full-screen trans-50"></div>
  </header>
  <section class="section s-home-brands-30px" data-aos="fade-up" data-aos-duration="2000">
    <div class="container-l">
      <div class="w-layout-grid grid _6er-brand">
        <div class="grid-item">
          <a href="https://www.damacproperties.com/en/" target="_blank" class="brand-icon-wrapper w-inline-block"><img src="../../assets/images/Gruppe-maskieren-89_1.svg" loading="lazy" alt="" class="brand-icon"></a>
        </div>
        <div class="grid-item">
          <a href="https://www.nakheel.com/homepage.html" class="brand-icon-wrapper w-inline-block"><img src="../../assets/images/Gruppe-maskieren-92.svg" loading="lazy" alt="" class="brand-icon"></a>
        </div>
        <div class="grid-item">
          <a href="https://www.dp.ae/" class="brand-icon-wrapper w-inline-block"><img src="../../assets/images/Gruppe-maskieren-93.svg" loading="lazy" alt="" class="brand-icon"></a>
        </div>
        <div class="grid-item">
          <a href="https://www.emaar.com/" class="brand-icon-wrapper w-inline-block"><img src="../../assets/images/Gruppe-maskieren-91.svg" loading="lazy" alt="" class="brand-icon"></a>
        </div>
        <div class="grid-item">
          <a href="https://www.sobha.com/" class="brand-icon-wrapper w-inline-block"><img src="../../assets/images/Gruppe-maskieren-90.svg" loading="lazy" alt="" class="brand-icon"></a>
        </div>
        <div class="grid-item">
          <a href="https://www.omniyat.com/" class="brand-icon-wrapper w-inline-block"><img src="../../assets/images/Gruppe-maskieren-95.svg" loading="lazy" alt="" class="brand-icon"></a>
        </div>
      </div>
      <div class="brand-banner-inner"></div>
    </div>
    <div class="bg-section bg-background"></div>
  </section>
  <section class="section standard no-overflow home-intro" data-aos="fade-up" data-aos-duration="2000">
    <div class="container-m">
      <div class="w-layout-grid grid _2er-c-left">
        <div id="w-node-a1e5806a-aae1-e627-355c-232b7255b496-88a991eb" class="grid-item p1">
          <div class="content-wrapper">
            <div data-w-id="09501cd5-0e77-3d72-1d94-81b158abcb46"  class="topline-wrapper b-30px">
              <div class="topline-line bg-primary"></div>
              <div class="text-topline">We are Hudson</div>
            </div>
            <h4 data-w-id="584eba46-a80f-38f0-3225-c91f435dee2c"  class="h2">A Boutique<br>Realtor in<br>Dubai</h4>
            <p data-w-id="6b899388-9e6c-cd62-9f18-e46bfa4e3b63"  class="text-normal max-85p">We curate our selection of properties, catering to our client&#x27;s vision of home. Hudson Real Estate provides exceptional service to ensure that we find homes our clients will love. Our passion to articulate unique experiences brings us formidable results. At Hudson, we want to create a journey to your ultimate home.<br><br></p>
            <div data-w-id="fbaf5c7a-9164-3b20-1527-c9a729598a51"  class="button-wrapper t-30px">
              <a [routerLink]="['/buy-properties']" class="button button-primary r-25px w-button">Property to buy</a>
              <div class="button-wrapper-inner xs-t-20px">
                <a [routerLink]="['/about']" class="button button-link w-button">ABOUT HUDSON</a>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-item">
          <div class="image-wrapper i-layers-left"><img src="../../assets/images/gs-1.svg" loading="lazy" width="876"  alt="" data-w-id="70b6d47d-49ba-e91b-2509-f4814ea3d75e" class="image i-layer-01 we-are-image-01"><img class="image i-layer-02 we-are-image-02" src="../../assets/images/HUDSON_House-living-room.jpg" width="876" alt=""  sizes="(max-width: 479px) 75vw, (max-width: 767px) 295.8359375px, 500px" data-w-id="926b0e04-e0ad-0587-5d40-0f88feb5b5ff" loading="lazy" srcset="../../assets/images/HUDSON_House-living-room-p-500.jpeg 500w, ../../assets/images/HUDSON_House-living-room.jpg 750w"></div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </section>
  <section class="section standard t-0px" data-aos="fade-up" data-aos-duration="2000">
    <div class="container-m">
      <div class="content-wrapper max-70p l-center">
        <div data-w-id="39197584-201a-bf5e-6376-eed3d6b18a7f"  class="topline-wrapper b-30px c-center">
          <div class="text-topline">Buying process</div>
          <div class="topline-line bg-primary c-center"></div>
        </div>
        <h4 data-w-id="094aa090-09ec-d573-4e26-e89169d3e7c8"  class="h2 l-center">AT HUDSON, WE KNOW WHAT IS BEST FOR YOU. BUYING A PROPERTY has NEVER been so EASY.<br></h4>
      </div>
      <div class="w-layout-grid grid _4er-home-buy-process">
        <div id="w-node-d75ebf7d-58d9-cee4-92c1-064e1907c4ff-88a991eb" data-w-id="d75ebf7d-58d9-cee4-92c1-064e1907c4ff"  class="grid-item">
          <div class="box-wrapper bg-light">
            <div class="flex-wrapper">
              <div class="box-content b-15px">
                <div class="text-highlight">01</div>
                <h4 class="h-steps">Step</h4>
              </div>
              <div class="line max-85p"></div>
              <div class="box-content t-15px">
                <div class="text-small">Buying a home for the first time can be challenging. To start the process, firstly get in touch with our team to discuss your several goals and requirements.</div>
              </div>
            </div>
          </div>
        </div>
        <div id="w-node-d56b3e93-ad92-8e50-3e6a-dbb59849ca13-88a991eb" data-w-id="d56b3e93-ad92-8e50-3e6a-dbb59849ca13"  class="grid-item">
          <div class="box-wrapper bg-light">
            <div class="flex-wrapper">
              <div class="box-content b-15px">
                <div class="text-highlight">02</div>
                <h4 class="h-steps">Step</h4>
              </div>
              <div class="line max-85p"></div>
              <div class="box-content t-15px">
                <div class="text-small">Our experts will get back to you with all the different options available, making sure to match your necessities and aspirations. </div>
              </div>
            </div>
          </div>
        </div>
        <div id="w-node-_4947b649-32a2-6f7c-ff5e-962e7393f59c-88a991eb" data-w-id="4947b649-32a2-6f7c-ff5e-962e7393f59c"  class="grid-item">
          <div class="box-wrapper bg-light">
            <div class="flex-wrapper">
              <div class="box-content b-15px">
                <div class="text-highlight">03</div>
                <h4 class="h-steps">Step</h4>
              </div>
              <div class="line max-85p"></div>
              <div class="box-content t-15px">
                <div class="text-small">After reviewing the properties, our team will walk you through the entire process from beginning to end to ensure everything is easy and practical for everyone. </div>
              </div>
            </div>
          </div>
        </div>
        <div id="w-node-_607b5e72-fa19-aa83-1406-6f5c456b9918-88a991eb" data-w-id="607b5e72-fa19-aa83-1406-6f5c456b9918"  class="grid-item">
          <a [routerLink]="['/contact']" class="box-wrapper bg-primary w-inline-block">
            <div class="flex-wrapper">
              <div class="box-content b-15px">
                <h4 class="h3 l-center text-background">Get in<br>touch</h4>
                <div class="text-small l-center text-background">Contact the Hudson team </div>
              </div>
              <div class="box-content">
                <div class="button-wrapper l-center">
                  <div class="button-plus"><img src="../../assets/images/Gruppe-717.svg" loading="lazy" alt="" class="icon h-16px"></div>
                </div>
              </div>
            </div><img src="../../assets/images/Gruppe-maskieren-60.svg" loading="lazy" alt="" class="image full-screen">
          </a>
        </div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </section>
  <div class="s-no-overflow" data-aos="fade-up" data-aos-duration="2000">
    <section class="section standard s-advantages">
      <div class="container-m">
        <div class="w-layout-grid grid _2er-advantages">
          <div class="grid-item">
            <div data-w-id="d431404a-75ac-f1ab-3248-dd0ddf992f61"  class="topline-wrapper b-30px">
              <div class="topline-line bg-primary"></div>
              <div class="text-topline text-background">Advantages</div>
            </div>
          </div>
          <div class="grid-item">
            <div class="content-wrapper">
              <h4 data-w-id="683af8aa-61e2-db20-a046-4a92313056b6"  class="h3 text-background">DISCOVER THE ADVANTAGES OF WORKING WITH OUR TEAM OF EXPERTS<span class="text-span"></span></h4>
            </div>
          </div>
        </div>
        <div class="w-layout-grid grid _3er-advantages">
          <div data-w-id="21b211cf-c907-3aa6-bac7-4e254c3bc6a6"  class="grid-item">
            <div class="content-wrapper">
              <div class="flex-wrapper">
                <div class="image-wrapper"><img src="../../assets/images/Gruppe-890.svg" loading="lazy" alt="" class="icon h-100px"></div>
                <div class="content-wrapper t-30px">
                  <div class="topline-wrapper b-5px">
                    <div class="text-topline text-lighter">01.</div>
                  </div>
                  <h4 class="h-caps text-background">lifestyle </h4>
                  <div class="text-small text-background">We define ourselves not only as real estate brokerage but as lifestyle managers. There are so many more needed factors to make our clients feel comfortable in their new homes, and here at Hudson, we take care of that.<br></div>
                </div>
              </div>
            </div>
          </div>
          <div data-w-id="12934ff0-2e2d-64e5-c441-60471df659a8"  class="grid-item">
            <div class="content-wrapper">
              <div class="flex-wrapper">
                <div class="image-wrapper"><img src="../../assets/images/Gruppe-728.svg" loading="lazy" alt="" class="icon h-100px"></div>
                <div class="content-wrapper t-30px">
                  <div class="topline-wrapper b-5px">
                    <div class="text-topline text-lighter">02.</div>
                  </div>
                  <h4 class="h-caps text-background">maintEnance </h4>
                  <div class="text-small text-background">Along with our maintenance team, we will professionally handle any required installation for your future home.<br><br></div>
                </div>
              </div>
            </div>
          </div>
          <div data-w-id="9bf07150-fa7b-f59a-4128-0753410731a6"  class="grid-item">
            <div class="content-wrapper">
              <div class="flex-wrapper">
                <div class="image-wrapper"><img src="../../assets/images/Gruppe-889.svg" loading="lazy" alt="" class="icon h-100px"></div>
                <div class="content-wrapper t-30px">
                  <div class="topline-wrapper b-5px">
                    <div class="text-topline text-lighter">03.</div>
                  </div>
                  <h4 class="h-caps text-background">DYNAMISM</h4>
                  <div class="text-small text-background">We are a young and dynamic team where every client gets equally treated with respect and professionalism.</div>
                </div>
              </div>
            </div>
          </div>
          <div data-w-id="4bc0dee0-5ad5-a6ac-c52c-826de2991815"  class="grid-item">
            <div class="content-wrapper">
              <div class="flex-wrapper">
                <div class="image-wrapper"><img src="../../assets/images/Gruppe-734.svg" loading="lazy" alt="" class="icon h-100px"></div>
                <div class="content-wrapper t-30px">
                  <div class="topline-wrapper b-5px">
                    <div class="text-topline text-lighter">04.<br></div>
                  </div>
                  <h4 class="h-caps text-background">INVESTMENT</h4>
                  <div class="text-small text-background">If you are looking for properties as an investment, our team can give you access to highly sophisticated funding possibilities.</div>
                </div>
              </div>
            </div>
          </div>
          <div data-w-id="f498bcae-e0eb-73c8-1bad-441e0ce54e8b"  class="grid-item">
            <div class="content-wrapper">
              <div class="flex-wrapper">
                <div class="image-wrapper"><img src="../../assets/images/Gruppe-888.svg" loading="lazy" alt="" class="icon h-100px"></div>
                <div class="content-wrapper t-30px">
                  <div class="topline-wrapper b-5px">
                    <div class="text-topline text-lighter">05.</div>
                  </div>
                  <h4 class="h-caps text-background">QUALITY</h4>
                  <div class="text-small text-background">In Hudson, we only work with the best developers and landlords in town. We always want to ensure that we provide our clients with the most reliable quality for their properties.</div>
                </div>
              </div>
            </div>
          </div>
          <div data-w-id="6afb4f7d-30ee-4b62-7e0c-f0eff08ace05"  class="grid-item">
            <div class="content-wrapper">
              <div class="flex-wrapper">
                <div class="image-wrapper"><img src="../../assets/images/Gruppe-887.svg" loading="lazy" alt="" class="icon h-100px"></div>
                <div class="content-wrapper t-30px">
                  <div class="topline-wrapper b-5px">
                    <div class="text-topline text-lighter">06.</div>
                  </div>
                  <h4 class="h-caps text-background">LONG-LASTING RELATIONSHIPS</h4>
                  <div class="text-small text-background">Our experts do not strive for one-off sales since we aim to build a long-lasting relationship with our clients. Whether it comes to reselling, furnishing, renovating, or renting, we are the right team for you.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-w-id="2d9b857c-2979-7fa9-074b-12a0839b2adc"  class="use-cases-slide-container">
          <div data-delay="4000" data-animation="slide" class="slider-use-cases w-slider" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="false">
            <swiper-container pagination="false" navigation="false" space-between="50" class="mask overflow-visible w-slider-mask">
              <swiper-slide class="slide-use-cases w-slide">
                <div class="content-wrapper use-cases-slider">
                  <div class="cw-01">
                    <div class="flex-wrapper">
                      <h3 class="h4 use-cases-title">WHAT OUR CLIENTS SAY ABOUT US </h3>
                    </div>
                  </div>
                  <div class="cw-02">
                    <div class="content-wrapper">
                      <div class="image-wrapper"><img src="../../assets/images/Gruppe-733.svg" loading="lazy" width="107" alt="" class="stars-icon"></div>
                      <div class="line space-20px trans-background-20p"></div>
                      <div class="content-wrapper max-55p">
                        <div class="text-normal text-lighter">Hudson Team, particularly Ajay, were able to sell my property in no time. Hudson&#x27;s commitment is to always give outstanding services, highly recommend.</div>
                        <div class="text-use-case">federico, investor</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="slide-bg">
                  <div class="overlay"></div><img src="../../assets/images/CREEK_PALACE_Kitchen.jpg" loading="lazy" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 92vw" srcset="../../assets/images/CREEK_PALACE_Kitchen-p-500.jpeg 500w, ../../assets/images/CREEK_PALACE_Kitchen.jpg 1200w" alt="" class="image full-screen">
                </div>
              </swiper-slide>
              <swiper-slide class="slide-use-cases w-slide">
                <div class="content-wrapper use-cases-slider">
                  <div class="cw-01">
                    <div class="flex-wrapper">
                      <h3 class="h4 use-cases-title">WHAT OUR CLIENTS SAY ABOUT US </h3>
                    </div>
                  </div>
                  <div class="cw-02">
                    <div class="content-wrapper">
                      <div class="image-wrapper"><img src="../../assets/images/Gruppe-733.svg" loading="lazy" width="107" alt="" class="stars-icon"></div>
                      <div class="line space-20px trans-background-20p"></div>
                      <div class="content-wrapper max-55p">
                        <div class="text-normal text-lighter">Investing in real estate was intimidating, but Hudson’s transparency and professionalism helped me navigate the market with ease.</div>
                        <div class="text-use-case">MARIA HERNANDEZ, BUSINESS OWNER</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="slide-bg">
                  <div class="overlay"></div><img src="../../assets/images/CREEK_PALACE_Living-EDIT.jpg" loading="lazy" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 92vw" srcset="../../assets/images/CREEK_PALACE_Living-EDIT-p-500.jpeg 500w, ../../assets/images/CREEK_PALACE_Living-EDIT-p-800.jpeg 800w, ../../assets/images/CREEK_PALACE_Living-EDIT-p-1080.jpeg 1080w, ../../assets/images/CREEK_PALACE_Living-EDIT.jpg 1300w" alt="" class="image full-screen">
                </div>
              </swiper-slide>
              <swiper-slide class="slide-use-cases w-slide">
                <div class="content-wrapper use-cases-slider">
                  <div class="cw-01">
                    <div class="flex-wrapper">
                      <h3 class="h4 use-cases-title">WHAT OUR CLIENTS SAY ABOUT US </h3>
                    </div>
                  </div>
                  <div class="cw-02">
                    <div class="content-wrapper">
                      <div class="image-wrapper"><img src="../../assets/images/Gruppe-733.svg" loading="lazy" width="107" alt="" class="stars-icon"></div>
                      <div class="line space-20px trans-background-20p"></div>
                      <div class="content-wrapper max-55p">
                        <div class="text-normal text-lighter">They took the time to understand our needs, preferences, and budget, ensuring that every property they showed us aligned perfectly with our criteria.</div>
                        <div class="text-use-case">CHRISTOPHER BARRET, GRAPHIC DESIGNER</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="slide-bg">
                  <div class="overlay"></div><img src="../../assets/images/CREEK_PALACE_Living-EDIT.jpg" loading="lazy" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 92vw" srcset="../../assets/images/CREEK_PALACE_Living-EDIT-p-500.jpeg 500w, ../../assets/images/CREEK_PALACE_Living-EDIT-p-800.jpeg 800w, ../../assets/images/CREEK_PALACE_Living-EDIT-p-1080.jpeg 1080w, ../../assets/images/CREEK_PALACE_Living-EDIT.jpg 1300w" alt="" class="image full-screen">
                </div>
              </swiper-slide>
              <swiper-slide class="slide-use-cases w-slide">
                <div class="content-wrapper use-cases-slider">
                  <div class="cw-01">
                    <div class="flex-wrapper">
                      <h3 class="h4 use-cases-title">WHAT OUR CLIENTS SAY ABOUT US </h3>
                    </div>
                  </div>
                  <div class="cw-02">
                    <div class="content-wrapper">
                      <div class="image-wrapper"><img src="../../assets/images/Gruppe-733.svg" loading="lazy" width="107" alt="" class="stars-icon"></div>
                      <div class="line space-20px trans-background-20p"></div>
                      <div class="content-wrapper max-55p">
                        <div class="text-normal text-lighter">When we relocated to Dubai, we were extremely fortunate to find Hudson. They helped us find the right property in the right community. We had an exceptional experience!</div>
                        <div class="text-use-case">ANANYA KHURANA, HR MANAGER </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="slide-bg">
                  <div class="overlay"></div><img src="../../assets/images/CREEK_PALACE_Living-EDIT.jpg" loading="lazy" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 92vw" srcset="../../assets/images/CREEK_PALACE_Living-EDIT-p-500.jpeg 500w, ../../assets/images/CREEK_PALACE_Living-EDIT-p-800.jpeg 800w, ../../assets/images/CREEK_PALACE_Living-EDIT-p-1080.jpeg 1080w, ../../assets/images/CREEK_PALACE_Living-EDIT.jpg 1300w" alt="" class="image full-screen">
                </div>
              </swiper-slide>
              <swiper-slide class="slide-use-cases w-slide">
                <div class="content-wrapper use-cases-slider">
                  <div class="cw-01">
                    <div class="flex-wrapper">
                      <h3 class="h4 use-cases-title">WHAT OUR CLIENTS SAY ABOUT US</h3>
                    </div>
                  </div>
                  <div class="cw-02">
                    <div class="content-wrapper">
                      <div class="image-wrapper"><img src="../../assets/images/Gruppe-733.svg" loading="lazy" width="107" alt="" class="stars-icon"></div>
                      <div class="line space-20px trans-background-20p"></div>
                      <div class="content-wrapper max-55p">
                        <div class="text-normal text-lighter">The team is brilliant. Hudson was able to understand everything that I was looking for in a property. They walked us through the entire process to make sure our experience was exceptional. </div>
                        <div class="text-use-case">haya hafeez, social media manager</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="slide-bg">
                  <div class="overlay"></div><img src="../../assets/images/Bathroom-Billboard-R02.jpg" loading="lazy" sizes="(max-width: 479px) 87vw, (max-width: 991px) 88vw, 92vw" srcset="../../assets/images/Bathroom-Billboard-R02-p-1080.jpeg 1080w, ../../assets/images/Bathroom-Billboard-R02.jpg 1200w" alt="" class="image full-screen">
                </div>
              </swiper-slide>
              <swiper-slide class="slide-use-cases w-slide">
                <div class="content-wrapper use-cases-slider">
                  <div class="cw-01">
                    <div class="flex-wrapper">
                      <h3 class="h4 use-cases-title">WHAT OUR CLIENTS SAY ABOUT US </h3>
                    </div>
                  </div>
                  <div class="cw-02">
                    <div class="content-wrapper">
                      <div class="image-wrapper"><img src="../../assets/images/Gruppe-733.svg" loading="lazy" width="107" alt="" class="stars-icon"></div>
                      <div class="line space-20px trans-background-20p"></div>
                      <div class="content-wrapper max-55p">
                        <div class="text-normal text-lighter">Hudson made our buying experience enjoyable and stress-free. They explained the process every step of the way, guiding and assisting us. Their professionalism is impeccable. </div>
                        <div class="text-use-case">james davies, regional manager </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="slide-bg">
                  <div class="overlay"></div><img src="../../assets/images/01-bedroom.jpg" loading="lazy" alt="" class="image full-screen">
                </div>
              </swiper-slide>
            </swiper-container>
            <div class="left-arrow w-slider-arrow-left"><img src="../../assets/images/Gruppe-717_1.svg" loading="lazy" width="25" alt="" class="image button-arrow rotate-180 s-hide"></div>
            <div class="right-arrow round-arrow w-slider-arrow-right"><img src="../../assets/images/Gruppe-870_1.svg" loading="lazy" width="25" alt="" class="image button-arrow s-hide"></div>
            <div class="slide-nav w-slider-nav w-round"></div>
          </div>
        </div>
      </div>
      <div class="bg-section bg-dark bg-rounded"><img src="../../assets/images/bg-gs.svg" loading="lazy" alt="" class="image full-screen"></div>
    </section>
    <section class="section standard sold-properties">
      <div class="container-m">
        <div class="w-layout-grid grid _3er-facts">
          <div id="w-node-_266878ee-74f6-ace1-5cb8-547ff297433c-88a991eb" data-w-id="266878ee-74f6-ace1-5cb8-547ff297433c"  class="grid-item">
            <div class="content-flex-inner">
              <div class="content-wrapper">
                <div class="text-highlight">300+</div>
              </div>
              <div class="content-wrapper l-15px">
                <div class="text-highlight-zusatz">Sold<br>properties</div>
              </div>
            </div>
          </div>
          <div id="w-node-ac79a07f-a505-2d28-8243-864384a3c821-88a991eb" data-w-id="ac79a07f-a505-2d28-8243-864384a3c821"  class="grid-item">
            <div class="content-flex-inner">
              <div class="content-wrapper">
                <div class="text-highlight">5000+</div>
              </div>
              <div class="content-wrapper l-15px">
                <div class="text-highlight-zusatz">VISITS<br>carried out</div>
              </div>
            </div>
          </div>
          <div id="w-node-_5cf23322-4029-e882-c159-632a268cfe7c-88a991eb" data-w-id="5cf23322-4029-e882-c159-632a268cfe7c"  class="grid-item">
            <div class="content-flex-inner">
              <div class="content-wrapper">
                <div class="text-highlight">20+</div>
              </div>
              <div class="content-wrapper l-15px">
                <div class="text-highlight-zusatz">EmployeEs<br>In the team</div>
              </div>
            </div>
          </div>
        </div>
        <div data-w-id="518c2270-5267-ace3-cdad-6431c7505bdc"  class="linie space-introduction"></div>
        <div class="hide">
          <div data-w-id="bdde2041-3393-8fc5-ee94-5ed15d551278"  class="topline-wrapper b-30px c-center">
            <div class="text-topline">Sold properties</div>
            <div class="topline-line bg-primary c-center"></div>
          </div>
          <div class="content-wrapper">
            <h4 data-w-id="87be54fe-efc8-84ed-9d48-1695677f0aae"  class="h2 l-center">explore our past properties </h4>
          </div>
        </div>
      </div>
      <div class="bg-section bg-light"></div>
    </section>
  </div>
  <section class="section standard t-0px overflow-hidden hide" data-aos="fade-up" data-aos-duration="2000">
    <div class="container-m">
      <div data-w-id="ca651cd6-2a12-dcd3-ee35-5198cddd5359"  class="content-wrapper">
        <div class="projects-col-list-wrap w-dyn-list">
          <div role="list" class="projects-col-list w-dyn-items">
            <div role="listitem" class="projects-col-item w-dyn-item">
              <div class="link-box box-sold-properties">
                <div class="content-wrapper-properties">
                  <div class="orga">
                    <h5 class="h4 text-background w-dyn-bind-empty"></h5>
                    <p class="text-small text-background w-dyn-bind-empty"></p>
                  </div>
                  <div class="orga">
                    <div class="h5 text-background">180,000,000 AED</div>
                    <div class="line-properties"></div>
                    <div class="properties-wrapper">
                      <div class="properties-content">
                        <div class="bedroom-wrapper">
                          <p class="text-details text-background">5</p>
                          <p class="text-details text-background l-5px">Bedrooms</p>
                        </div>
                        <p class="text-details text-background">•</p>
                        <div class="bathroom-wrapper">
                          <p class="text-details text-background">5</p>
                          <p class="text-details text-background l-5px">Bathrooms</p>
                        </div>
                      </div>
                      <div class="sold-button l-30px">
                        <div class="sold-icon"><img src="../../assets/images/Pfad-4760.svg" loading="lazy" width="10" alt="" class="sold-image"></div>
                        <div class="sold-text">Sold</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="image-wrapper full-screen"><img src="" loading="lazy" alt="" class="image full-screen w-dyn-bind-empty">
                  <div class="overlay"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="empty-state w-dyn-empty">
            <div>No items found.</div>
          </div>
        </div>
        <div class="w-embed">
          <style>/* owl slider */
.projects-col-list {
  display: flex;
  align-items: center;
  }
.carousel-wrap{
  width: 1000px;
  margin: auto;
  position: relative;
}
.owl-carousel .owl-nav{
  overflow: hidden;
  height: 0px;
}
.owl-stage {
  display: -webkit-flex;
 display: -ms-flexbox;
 display: flex;
 -webkit-flex-direction: row;
 -ms-flex-direction: row;
  flex-direction: row;
 -webkit-align-items: stretch;
 -ms-flex-align: stretch;
  align-items: stretch;
 -webkit-justify-content: space-between;
 -ms-flex-pack: justify;
  justify-content: space-between; 
}
.owl-stage-outer {
width: 100%;
}
.owl-dots {
text-align: center;
}
.owl-dot {
background: none;
padding: 5px;
margin: 3px 10px;
border:1px solid rgba(0,0,0,0.1);
}
.owl-dot.active {
background: none;
}
.owl-nav {
margin: 30px 0;
position: absolute;
width: 100%;
display: flex;
justify-content: space-between;
}
.owl-prev {
border-radius: 1000px;
border-color: #B8926A;
border-width: 1px;
border-style: solid;
background-color: transparent;
position: relative;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 90px;
  height: 90px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.owl-next {
  border-radius: 1000px;
border-color: #B8926A;
border-width: 1px;
border-style: solid;
background-color: transparent;
position: relative;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 90px;
  height: 90px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.nav-btn.next-slide {
  background: url(https://uploads-ssl.webflow.com/6151b3e24bcfa251089d2154/615876ba8f900b418c282da4_Gruppe%20870.svg);
height: 12px;
width: 25px;
background-position: center;
background-repeat: no-repeat;
}
.nav-btn.prev-slide {
  background: url(https://uploads-ssl.webflow.com/6151b3e24bcfa251089d2154/615876bb9c277884965f6747_Gruppe%20871.svg);
height: 12px;
width: 25px;
background-position: center;
background-repeat: no-repeat;
}
.owl-next:hover, .owl-prev:hover {
background-color: #B8926A;
border-color: #B8926A;
border: 1px;
}
</style>
        </div>
      </div>
      <div data-w-id="f00d491a-b5ee-8081-9c6f-df2f07e3fe97"  class="button-wrapper l-center t-50px">
        <a href="sold-properties.html" class="button button-primary r-25px w-button">All sold properties</a>
      </div>
    </div>
    <div class="bg-section bg-background">
      <div class="bg-inner-color h-50p bg-light"></div>
    </div>
  </section>
  <section class="section no-overflow" data-aos="fade-up" data-aos-duration="2000">
    <div class="container-m">
      <div class="w-layout-grid grid _2er-c-right">
        <div id="w-node-_04f2b67e-3969-538f-4601-06cd0be5159d-88a991eb" class="grid-item">
          <div class="image-wrapper i-layers-right"><img src="../../assets/images/gs-2.svg" loading="lazy" width="876"  alt="" data-w-id="703095e0-b998-255d-cfa1-fd0533fb1638" class="image i-layer-01 our-services-image-01"><img class="image i-layer-02 our-services-image-02" src="../../assets/images/HUDSON-bathroom.jpg" width="876" alt=""  sizes="(max-width: 479px) 75vw, (max-width: 767px) 296px, 500px" data-w-id="703095e0-b998-255d-cfa1-fd0533fb1639" loading="lazy" srcset="../../assets/images/HUDSON-bathroom-p-500.jpeg 500w, ../../assets/images/HUDSON-bathroom.jpg 800w"></div>
        </div>
        <div id="w-node-_04f2b67e-3969-538f-4601-06cd0be5158b-88a991eb" class="grid-item p1">
          <div class="content-wrapper">
            <div data-w-id="04f2b67e-3969-538f-4601-06cd0be5158d"  class="topline-wrapper b-30px">
              <div class="topline-line bg-primary"></div>
              <div class="text-topline">Our Services</div>
            </div>
            <h4 data-w-id="04f2b67e-3969-538f-4601-06cd0be51591"  class="h2">WE ARE THE RIGHT TEAM TO FULFILL YOUR NEEDS<br></h4>
            <p data-w-id="04f2b67e-3969-538f-4601-06cd0be51597"  class="text-normal">Whether you are looking to sell or rent your property, our team will make sure to provide you with the best guidance along the process. We are equipped with strong professionals that can assist you with residential sales and leasing, commercial sales and leasing, property management advisory, holiday homes advisory, mortgage consultancy, property evaluation advisory and property renovation advisory.<br>Discover our range of services. We deliver the finest customer service and commitment to our clients.<br></p>
            <div data-w-id="04f2b67e-3969-538f-4601-06cd0be5159a"  class="button-wrapper t-30px">
              <a [routerLink]="['/services']" class="button button-primary r-25px w-button">All services</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-light"></div>
  </section>
  <section class="section standard no-overflow" data-aos="fade-up" data-aos-duration="2000">
    <div class="container-m">
      <div class="w-layout-grid grid _2er-c-left">
        <div id="w-node-_20cbce53-a35a-ba28-b095-be02bcb2b160-bcb2b15d" class="grid-item p1">
          <div class="content-wrapper">
            <div data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b162" class="topline-wrapper b-30px">
              <div class="topline-line bg-primary"></div>
              <div class="text-topline">COntact</div>
            </div>
            <h4 data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b166" class="h2"><strong>GET IN TOUCH </strong></h4>
            <p data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b168" class="text-normal max-75p">Contact our real estate experts to discuss your needs. Our team has the expertise to guide you through the entire process.<br></p>
            <div data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b16b" class="button-wrapper t-30px xs-vertical">
              <a [routerLink]="['/contact']" class="button button-primary r-25px w-button">contact us</a>
              <div class="button-wrapper-inner xs-l-20px">
                <a href="tel:+97145693115" class="button button-link w-button">+971 4 380 5710</a>
              </div>
            </div>
          </div>
        </div>
        <div id="w-node-_20cbce53-a35a-ba28-b095-be02bcb2b16e-bcb2b15d" class="grid-item">
          <div class="image-wrapper i-layers-left"><img src="../../assets/images/gs-3.svg" loading="lazy" width="876" data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b170" alt="" class="image i-layer-01 contact-01">
            <div data-w-id="20cbce53-a35a-ba28-b095-be02bcb2b171" class="form-block-cta w-form">
              <!-- <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="615ea8ddc2e661bd88a991eb" data-wf-element-id="20cbce53-a35a-ba28-b095-be02bcb2b172"> -->
                <h4 class="h-form text-background">Get the<br><span class="text-span">Newsletter</span></h4>
                <p class="text-normal text-background">Sign up to get the latest updates delivered right to your inbox.<br></p>
                <div class="text-field-wrapper t-20px"><input class="text-field w-input" maxlength="256" name="email-2" data-name="Email 2" placeholder="E-Mail-Address" type="email" id="email-2" required=""><input type="submit" data-wait="" class="submit-button w-button" value=""></div><label class="w-checkbox checkbox-label"><input type="checkbox" id="checkbox" name="checkbox" data-name="Checkbox" required="" class="w-checkbox-input checkbox-hudson"><span class="text-xsmall text-background w-form-label" for="checkbox">I agree to the Terms of Service and Privacy Policy</span></label>
              <!-- </form> -->
              <div class="form__success w-form-done">
                <div class="text-background">Thank you! Your submission has been received!</div>
              </div>
              <div class="error-message w-form-fail">
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-light"></div>
  </section>
  <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js"></script>
  
  <script>
   $('.projects-col-list.w-dyn-items').owlCarousel({
            margin: 15,
            nav: true,
            loop:true,
            animateIn:true,
            navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 3
                }
            }
        });
 </script>
  <script>
   $('.recipe-col-list.w-dyn-items').owlCarousel({
            margin: 15,
            nav: true,
            loop:true,
            animateIn:true,
            navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 2
                },
                1000: {
                    items: 2
                },
               1500: {
                items:4
              }
            }
        });
 </script>